import { useEffect, useState } from 'react';
import { Button, Group, Modal, Stack, Text, Textarea } from '@cowbell/ui/core';

interface DeclineProductModalProps {
  opened: boolean;
  productName: string;
  onClose: () => void;
  onConfirm: (declinedReason: string) => void | Promise<void>;
  isSubmitting: boolean;
}

export const DeclineProductModal = (props: DeclineProductModalProps) => {
  const [declineReasonDraft, setDeclineReasonDraft] = useState('');
  const [declineReasonError, setDeclineReasonError] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (props.opened) {
      setDeclineReasonDraft('');
      setDeclineReasonError(null);
    }
  }, [props.opened]);

  const handleSubmit = async () => {
    if (!declineReasonDraft.trim()) {
      setDeclineReasonError('Enter a reason for declining this product.');
      return;
    }

    setDeclineReasonError(null);
    await props.onConfirm(declineReasonDraft.trim());
  };

  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title="Decline product"
      size="md"
      centered
      withinPortal={false}
    >
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          Provide a short reason for declining{' '}
          <Text span fw={600}>
            {props.productName}
          </Text>
          . The policyholder will see this reason with the declined status.
        </Text>
        <Textarea
          label="Decline reason"
          placeholder="e.g. Installed version does not match evidence provided"
          rows={5}
          value={declineReasonDraft}
          onChange={(event) => {
            setDeclineReasonDraft(event.currentTarget.value);

            if (declineReasonError) {
              setDeclineReasonError(null);
            }
          }}
          error={declineReasonError}
          disabled={props.isSubmitting}
        />
        <Group justify="flex-end" gap="sm">
          <Button
            variant="subtle"
            onClick={props.onClose}
            disabled={props.isSubmitting}
          >
            Cancel
          </Button>
          <Button
            color="red"
            onClick={handleSubmit}
            loading={props.isSubmitting}
          >
            Decline product
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
